import { Avatar, AvatarFallback, AvatarImage } from "@shared-kernel/primary/shared/shadcn/ui/avatar";
import { Badge } from "@shared-kernel/primary/shared/shadcn/ui/badge";
import type { ActivityCardEntry } from "./types";
import { getBadgeStyles } from "./activity-card-utils";

interface ActivityCardAvatarProps {
  entry: ActivityCardEntry;
}

export const ActivityCardAvatar = ({ entry }: ActivityCardAvatarProps) => (
  <Avatar className="size-12">
    {entry.avatarUrl && <AvatarImage src={entry.avatarUrl} alt={entry.primaryText} />}
    <AvatarFallback className="bg-border font-medium text-foreground">{entry.avatarInitials}</AvatarFallback>
  </Avatar>
);

interface ActivityCardContentProps {
  entry: ActivityCardEntry;
}

export const ActivityCardContent = ({ entry }: ActivityCardContentProps) => {
  const badgeStyles = getBadgeStyles(entry.badgeVariant);
  const secondaryBadgeStyles = entry.secondaryBadgeVariant ? getBadgeStyles(entry.secondaryBadgeVariant) : null;

  return (
    <div className="space-y-0.5">
      <div className="flex flex-wrap items-center gap-2">
        <span className="font-bold">{entry.primaryText}</span>
        {entry.badge && (
          <Badge variant={badgeStyles.variant} className={badgeStyles.className}>
            {entry.badge}
          </Badge>
        )}
        {entry.secondaryBadge && secondaryBadgeStyles && (
          <Badge variant={secondaryBadgeStyles.variant} className={secondaryBadgeStyles.className}>
            {entry.secondaryBadge}
          </Badge>
        )}
      </div>
      {entry.secondaryText && <p className="text-sm text-muted-foreground">{entry.secondaryText}</p>}
      {entry.tertiaryText && <p className="text-sm text-muted-foreground">{entry.tertiaryText}</p>}
    </div>
  );
};
